export const SITE_URL = "https://shonaslang.com";

/** The publisher for JSON-LD. Google wants a square logo of at least 112 px. */
export function organizationJsonLd() {
  return {
    "@type": "Organization",
    name: "shonaslang",
    url: SITE_URL,
    logo: {
      "@type": "ImageObject",
      url: `${SITE_URL}/logo-512x512.png`,
      width: 512,
      height: 512,
    },
  };
}
